export const setOrganization = (state) => state.organization.organizationData;

export const getFeaturesList = (state) => state.organization.features;